const Settings = () => {
  return (<>Settings</>)
}

const SettingsEdit = () => {
  return (<></>)
}

export {Settings, SettingsEdit};